module.exports = __webpack_public_path__ + "static/media/TheYearMyLifeWentDowntheToiletBookJacket.8e1602d5.jpg";